import { PerformanceReviewOverviewPageLocationsFragment } from 'generated/resources/graphql'

import Filter from 'modules/core/components/Filter'
import i18n from 'modules/core/lib/i18n'

import { useFilter, useNewlyAddedFilters } from '../context'

type WorkplaceFilterProps = {
  locations: PerformanceReviewOverviewPageLocationsFragment[]
}

export const WorkplaceFilter = ({ locations }: WorkplaceFilterProps) => {
  const { value, setValue } = useFilter('workplaceIds')
  const { newlyAddedFilters } = useNewlyAddedFilters()

  const options =
    locations.map((location) => ({
      label: location.name,
      value: location.id,
    })) ?? []

  if (options.length === 0) return null

  return (
    <Filter.MultipleChoice
      label={i18n.t('performance_process.reviews.filters.workplace')}
      value={value}
      options={options}
      onValueChange={(newValue) => setValue(newValue ?? [])}
      defaultOpen={newlyAddedFilters.includes('workplaceIds')}
    />
  )
}
